
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/dock-door-management",
      function () {
        return require("private-next-pages/ai/dock-door-management.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/dock-door-management"])
      });
    }
  